<template>
  <div class="tab-pane active" id="sms-stats3">
    <div class="card-body">
      <div class="loading min-h-300" v-if="loading">
        <LoadingAnim />
      </div>
      <div v-else class="table-responsive">
        <div
          v-if="!usageRecords && fetched"
          class="text-center table-placeholder"
        >
          <br />
          <i class="fas fa-tachometer-alt font-size-80"></i>
          <h5 class="card-title m-t-20">Nenhum gasto encontrado</h5>
        </div>
        <table class="table table-borderless">
          <thead class="">
            <tr>
              <th>{{ $tc('generic-str.lbl-product', 1) }}</th>
              <th>{{ $t('app.quantity') }}</th>
              <th>{{ $t('generic-str.lbl-cost') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="usageRecord in usageRecords" :key="usageRecord.name">
              <td>
                {{ usageRecord.description }}
              </td>
              <td>{{ usageRecord.count }}</td>
              <td>{{ usageRecord.price | currency4D }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import moment from 'moment';
import Tab from '@/directives/Tab';
import LoadingAnim from '@/components/rebranding/animLottie/Loading.vue';

export default {
  name: 'PipelineReport',
  components: {
    LoadingAnim,
  },
  directives: {
    Tab,
  },
  props: {
    startDate: {
      type: String,
    },
    endDate: {
      type: String,
    },
  },
  data() {
    return {
      fetchTimeout: 0,
      loading: false,
      options: {
        timePicker: false,
        autoApply: true,
        className: 'form-control',
        startDate: moment().format('01/MM/YYYY'),
        maxSpan: {
          days: 31,
        },
        locale: {
          format: 'DD/MM/YYYY',
          daysOfWeek: ['Do', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sa'],
          monthNames: [
            'Jan',
            'Fev',
            'Mar',
            'Abr',
            'Mai',
            'Jun',
            'Jul',
            'Ago',
            'Set',
            'Otu',
            'Nov',
            'Dez',
          ],
        },
      },
      usageRecords: [],
      form: {
        category: 'sms',
        date: {
          gte: moment().format('YYYY-MM-01'),
          lte: moment().format('YYYY-MM-DD'),
        },
      },
    };
  },
  created() {
    this.fetch();
  },
  methods: {
    fetch(page = 1) {
      this.loading = true;

      this.$store
        .dispatch('fetchUsage', {
          filter: {
            ...this.filters,
            category: 'sms',
            date: {
              gte: this.startDate,
              lte: this.endDate,
            },
          },
          page,
        })
        .then((response) => {
          this.usageRecords = response.data;
          this.pages = response.last_page;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.table-responsive {
  min-height: 150px;
}
</style>
